"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var Participant = /** @class */ (function () {
    function Participant(connection, userInfo, roles) {
        this.connection = connection;
        this.$manager = new rxjs_1.Subject();
        this.isSpeaking = false;
        if (userInfo) {
            this.isStaff = userInfo.isStaff;
            this.isMain = userInfo.isMain;
            this.role = roles[userInfo.userRoleId];
            this.name = userInfo.name;
            this.onBehalfOf = userInfo.onBehalfOf;
            this.isBenchMember = userInfo.isBenchMember;
            this.connectionRole = userInfo.connectionRole;
            this.USERID = userInfo.USERID;
        }
    }
    Object.defineProperty(Participant.prototype, "published", {
        get: function () {
            return !!this.connection.stream;
        },
        enumerable: true,
        configurable: true
    });
    Participant.prototype.setManager = function (manager) {
        if (this.manager) {
            this.manager.off('publisherStartSpeaking');
            this.manager.off('publisherStopSpeaking');
        }
        this.manager = manager;
        this.updateManager();
    };
    Participant.prototype.managerChanges = function () {
        return this.$manager.asObservable();
    };
    Participant.prototype.updateManager = function () {
        this.$manager.next(this.manager);
    };
    return Participant;
}());
exports.Participant = Participant;
//# sourceMappingURL=participant.js.map